import classNames from 'classnames';
import { Button as Buttons } from 'reactstrap';
import styled from 'styled-components';

const LoadingIcon = ({ classes, className }) => (
  <i className={`${classNames('bx bx-loader-alt bx-spin-fast btn-loading-icon', classes, className)}`} />
);
const StyledButton = styled(Buttons)`
  display: flex;
  align-items: center;
  justify-content: center;
  &.btn-loading {
    cursor: not-allowed;
    pointer-events: unset;
  }
`;
const StyledLoadingIcon = styled(LoadingIcon)`
  font-size: 24px;
  margin-right: ${(props) => (props.children ? '8px' : 0)};
`;

const Icon = styled.div`
  margin-left: ${(props) => (props.right ? '8px' : 0)};
  margin-right: ${(props) => (props.left ? '8px' : 0)};
`;

const Button = ({
  children,
  className,
  color,
  outline,
  size,
  block,
  active,
  close,
  isLoading,
  leftIcon,
  rightIcon,
  ...props
}) => (
  <StyledButton
    className={`${classNames(className, isLoading ? 'btn-loading' : null)}`}
    color={color}
    outline={outline}
    size={size}
    block={block}
    active={active}
    close={close}
    disabled={isLoading || props.disabled}
    {...props}
  >
    {isLoading
      ? <StyledLoadingIcon>{children}</StyledLoadingIcon>
      : leftIcon
        ? <Icon left>{leftIcon}</Icon>
        : null}
    {children}
    {isLoading ? null : rightIcon ? <Icon right>{rightIcon}</Icon> : null}
  </StyledButton>
);

export default Button;
